<template>
  <transition name="fade">
    <div v-if="visible" class="overlay">
      <div class="countdown">{{ countdownText }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    playSound: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      countdown: 0,
      interval: null,
    };
  },
  computed: {
    countdownText() {
      return this.countdown === 0 ? "Los!" : this.countdown;
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.startCountdown();
      } else {
        this.resetCountdown();
      }
    },
  },
  methods: {
    startCountdown() {
      this.countdown = this.duration;
      this.playBeep(this.countdown); // Sofort ein erster Piepton für die Startzahl

      this.interval = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--;
          this.playBeep(this.countdown);
        } else if (this.countdown === 1) {
          this.countdown--;
          this.playFinalBeep();
        } else {
          clearInterval(this.interval);
          this.$emit("countdown-finished");
        }
      }, 1000);
    },
    resetCountdown() {
      clearInterval(this.interval);
      this.countdown = this.duration;
    },
    playBeep() {
      if (!this.playSound) return;
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioCtx.createOscillator();
      const gainNode = audioCtx.createGain();

      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(300 + 5 * 50, audioCtx.currentTime);
      gainNode.gain.setValueAtTime(0.5, audioCtx.currentTime);

      oscillator.connect(gainNode);
      gainNode.connect(audioCtx.destination);

      oscillator.start();
      oscillator.stop(audioCtx.currentTime + 0.2);
    },
    playFinalBeep() {
      if (!this.playSound) return;
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioCtx.createOscillator();
      const gainNode = audioCtx.createGain();

      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(1000, audioCtx.currentTime);
      gainNode.gain.setValueAtTime(0.6, audioCtx.currentTime);

      oscillator.connect(gainNode);
      gainNode.connect(audioCtx.destination);

      oscillator.start();
      oscillator.stop(audioCtx.currentTime + 0.5);
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.countdown {
  color: white;
  font-size: 40vh;
  font-weight: bold;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
